import { v4 as uuidv4 } from 'uuid';

import { Wheel, WheelEntryType, WheelTheme } from '../types/wheel';

// Tribute Roulette Wheel
const tributeRoulette: Wheel = {
  id: '1e9a8b7c-6d5e-4f3c-2d1b-0a9b8c7d6e5f',
  name: 'Tribute Roulette',
  theme: WheelTheme.DEFAULT, // Standardized to DEFAULT theme
  spinCount: 1284,
  favorites: 0,
  createdAt: new Date('2025-03-12'),
  updatedAt: new Date('2025-03-12'),
  createdBy: 'system',
  isPublic: true,
  category: 'challenges',
  difficulty: 2,
  tags: ['challenge', 'money', 'fun'],
  wheelSettings: {
    allowDuplicateSpins: true,
    wheelStyle: 'default',
  },
  entries: [
    {
      id: uuidv4(),
      text: 'Send $25 tribute',
      type: WheelEntryType.TEXT,
      weight: 2,
      emoji: '💰',
    },
    {
      id: uuidv4(),
      text: 'Send $50 tribute',
      type: WheelEntryType.TEXT,
      weight: 1.5,
      emoji: '💸',
    },
    {
      id: uuidv4(),
      text: 'Send $100 tribute',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '💵',
    },
    {
      id: uuidv4(),
      text: 'Buy item from wishlist',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🎁',
    },
    {
      id: uuidv4(),
      text: 'Double next tribute',
      type: WheelEntryType.CHALLENGE,
      weight: 1,
      emoji: '⚡',
    },
    {
      id: uuidv4(),
      text: 'Safe - No tribute this time',
      type: WheelEntryType.REWARD,
      weight: 0.5,
      emoji: '🛡️',
    },
    {
      id: uuidv4(),
      text: 'Send $75 tribute',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '💰',
    },
    {
      id: uuidv4(),
      text: 'Weekly donation',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '📅',
    },
    {
      id: uuidv4(),
      text: 'Tribute + 20%',
      type: WheelEntryType.CHALLENGE,
      weight: 1,
      emoji: '📈',
    },
    {
      id: uuidv4(),
      text: 'Amazon gift card',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '🎯',
    },
  ],
};

// Payday Drain Wheel
const paydayDrain: Wheel = {
  id: '2f8a7b6c-5d4e-3f2c-1d0b-9a8b7c6d5e4f',
  name: 'Payday Drain',
  theme: WheelTheme.DEFAULT, // Standardized to DEFAULT theme
  spinCount: 876,
  favorites: 0,
  createdAt: new Date('2025-02-03'),
  updatedAt: new Date('2025-02-03'),
  createdBy: 'system',
  isPublic: true,
  category: 'findom',
  difficulty: 3,
  tags: ['payday', 'findom', 'money'],
  wheelSettings: {
    allowDuplicateSpins: true,
    wheelStyle: 'default',
  },
  entries: [
    {
      id: uuidv4(),
      text: '10% of Paycheck',
      type: WheelEntryType.TEXT,
      weight: 2,
      emoji: '💸',
    },
    {
      id: uuidv4(),
      text: '25% of Paycheck',
      type: WheelEntryType.TEXT,
      weight: 1.5,
      emoji: '💰',
    },
    {
      id: uuidv4(),
      text: '50% of Paycheck',
      type: WheelEntryType.CHALLENGE,
      weight: 0.8,
      emoji: '🔥',
    },
    {
      id: uuidv4(),
      text: 'Mercy - 5% Only',
      type: WheelEntryType.REWARD,
      weight: 0.5,
      emoji: '😇',
    },
    {
      id: uuidv4(),
      text: 'Weekly Allowance Set',
      type: WheelEntryType.CHALLENGE,
      weight: 1,
      emoji: '📊',
    },
    {
      id: uuidv4(),
      text: 'Expense Report Task',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '📝',
    },
    {
      id: uuidv4(),
      text: 'Payday Loan for Tribute',
      type: WheelEntryType.CHALLENGE,
      weight: 0.7,
      emoji: '🏦',
    },
    {
      id: uuidv4(),
      text: '15% of Paycheck',
      type: WheelEntryType.TEXT,
      weight: 1.8,
      emoji: '💵',
    },
    {
      id: uuidv4(),
      text: 'Budget Approval Required',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '✅',
    },
  ],
};

// Budget Breaker Wheel
const budgetBreaker: Wheel = {
  id: '3e7a6b5c-4d3e-2f1c-0d9b-8a7b6c5d4e3f',
  name: 'Budget Breaker',
  theme: WheelTheme.DEFAULT, // Standardized to DEFAULT theme
  spinCount: 543,
  favorites: 0,
  createdAt: new Date('2025-03-25'),
  updatedAt: new Date('2025-03-25'),
  createdBy: 'system',
  isPublic: true,
  category: 'findom',
  difficulty: 2,
  tags: ['budget', 'findom', 'money'],
  wheelSettings: {
    allowDuplicateSpins: true,
    wheelStyle: 'default',
  },
  entries: [
    {
      id: uuidv4(),
      text: 'Break Savings Rule',
      type: WheelEntryType.CHALLENGE,
      weight: 1,
      emoji: '💔',
    },
    {
      id: uuidv4(),
      text: 'Luxury Purchase Task',
      type: WheelEntryType.TEXT,
      weight: 1.5,
      emoji: '👑',
    },
    {
      id: uuidv4(),
      text: 'Budget Freeze - No Spending',
      type: WheelEntryType.REWARD,
      weight: 0.5,
      emoji: '❄️',
    },
    {
      id: uuidv4(),
      text: 'Unexpected Expense',
      type: WheelEntryType.CHALLENGE,
      weight: 1.2,
      emoji: '⚠️',
    },
    {
      id: uuidv4(),
      text: 'Shopping Spree Task',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🛍️',
    },
    {
      id: uuidv4(),
      text: 'Credit Card Maxing',
      type: WheelEntryType.CHALLENGE,
      weight: 0.7,
      emoji: '💳',
    },
    {
      id: uuidv4(),
      text: 'Budget Recalculation',
      type: WheelEntryType.TEXT,
      weight: 1.3,
      emoji: '🧮',
    },
    {
      id: uuidv4(),
      text: 'Financial Confession',
      type: WheelEntryType.TEXT,
      weight: 1.1,
      emoji: '🗣️',
    },
    {
      id: uuidv4(),
      text: 'Emergency Fund Tap',
      type: WheelEntryType.CHALLENGE,
      weight: 0.8,
      emoji: '🚨',
    },
    {
      id: uuidv4(),
      text: 'Budget Audit',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '📋',
    },
    {
      id: uuidv4(),
      text: 'Impulse Buy Challenge',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🎯',
    },
  ],
};

// Wishlist Worship Wheel
const wishlistWorship: Wheel = {
  id: '4d6a5b4c-3d2e-1f0c-9d8b-7a6b5c4d3e2f',
  name: 'Wishlist Worship',
  theme: WheelTheme.DEFAULT, // Standardized to DEFAULT theme
  spinCount: 722,
  favorites: 0,
  createdAt: new Date('2025-01-15'),
  updatedAt: new Date('2025-01-15'),
  createdBy: 'system',
  isPublic: true,
  category: 'wishlist',
  difficulty: 1,
  tags: ['wishlist', 'findom', 'gifts'],
  wheelSettings: {
    allowDuplicateSpins: true,
    wheelStyle: 'default',
  },
  entries: [
    {
      id: uuidv4(),
      text: 'Buy Lowest Item',
      type: WheelEntryType.TEXT,
      weight: 1.5,
      emoji: '🛒',
    },
    {
      id: uuidv4(),
      text: 'Buy Mid-Range Item',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🎁',
    },
    {
      id: uuidv4(),
      text: 'Buy Premium Item',
      type: WheelEntryType.TEXT,
      weight: 0.5,
      emoji: '💎',
    },
    {
      id: uuidv4(),
      text: 'Wishlist Window Shopping Only',
      type: WheelEntryType.REWARD,
      weight: 0.7,
      emoji: '👀',
    },
    {
      id: uuidv4(),
      text: 'Add New Items to Wishlist',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '📝',
    },
    {
      id: uuidv4(),
      text: 'Priority Shipping Upgrade',
      type: WheelEntryType.CHALLENGE,
      weight: 1,
      emoji: '🚚',
    },
    {
      id: uuidv4(),
      text: 'Buy Two Items',
      type: WheelEntryType.CHALLENGE,
      weight: 0.8,
      emoji: '✌️',
    },
    {
      id: uuidv4(),
      text: 'Gift Card Purchase',
      type: WheelEntryType.TEXT,
      weight: 1.3,
      emoji: '💳',
    },
    {
      id: uuidv4(),
      text: 'Surprise Gift Selection',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🎲',
    },
  ],
};

// Wallet Wrecker Wheel
const walletWrecker: Wheel = {
  id: '5c4a3b2c-1d0e-9f8c-7d6b-5a4b3c2d1e0f',
  name: 'Wallet Wrecker',
  theme: WheelTheme.DEFAULT,
  spinCount: 1097,
  favorites: 0,
  createdAt: new Date('2025-02-28'),
  updatedAt: new Date('2025-02-28'),
  createdBy: 'system',
  isPublic: true,
  category: 'findom',
  difficulty: 4,
  tags: ['tribute', 'findom', 'money', 'extreme'],
  wheelSettings: {
    allowDuplicateSpins: true,
    wheelStyle: 'default',
  },
  entries: [
    {
      id: uuidv4(),
      text: '$200 Tribute',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '💰',
    },
    {
      id: uuidv4(),
      text: '$500 Tribute',
      type: WheelEntryType.CHALLENGE,
      weight: 0.5,
      emoji: '💸',
    },
    {
      id: uuidv4(),
      text: 'Wallet Drain Challenge',
      type: WheelEntryType.CHALLENGE,
      weight: 0.7,
      emoji: '🔥',
    },
    {
      id: uuidv4(),
      text: 'Mercy - $50 Only',
      type: WheelEntryType.REWARD,
      weight: 0.3,
      emoji: '😇',
    },
    {
      id: uuidv4(),
      text: '$150 Tribute',
      type: WheelEntryType.TEXT,
      weight: 1.2,
      emoji: '💵',
    },
    {
      id: uuidv4(),
      text: 'Financial Domination Task',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '👑',
    },
    {
      id: uuidv4(),
      text: 'Expense Approval for 1 Week',
      type: WheelEntryType.CHALLENGE,
      weight: 0.8,
      emoji: '📊',
    },
    {
      id: uuidv4(),
      text: '$300 Tribute',
      type: WheelEntryType.CHALLENGE,
      weight: 0.7,
      emoji: '💰',
    },
    {
      id: uuidv4(),
      text: 'Financial Confession',
      type: WheelEntryType.TEXT,
      weight: 1,
      emoji: '🗣️',
    },
    {
      id: uuidv4(),
      text: 'Recurring Payment Setup',
      type: WheelEntryType.CHALLENGE,
      weight: 0.6,
      emoji: '⏱️',
    },
  ],
};

// Export as array
export const mockWheels: Wheel[] = [
  tributeRoulette,
  paydayDrain,
  budgetBreaker,
  wishlistWorship,
  walletWrecker,
];

// Helper functions
export const getAllWheels = (): Wheel[] => mockWheels;
export const getWheelById = (id: string): Wheel | undefined =>
  mockWheels.find(wheel => wheel.id === id);
